import React from 'react';
import { Table } from 'reactstrap';
import { formatPrice } from '@/utils/formatter';

export function InvoiceAdminDetailInfo({ adminInfo }: { adminInfo: any }) {
  const {
    charged_at,
    charged_amount,
    charged_currency,
    charged_transaction_id,
    charged_charge_id,
    send_at,
    send_status,
    send_error,
    send_emails_used,
    send_delivery_link,
  } = adminInfo;
  return (
    <div>
      <b>Charged</b>
      <Table striped bordered hover size="sm">
        <tbody>
          <tr>
            <td>charged at:</td>
            <td>{charged_at}</td>
          </tr>
          <tr>
            <td>charged amount:</td>
            <td className="numbers-formatted">
              {formatPrice(charged_amount)} {charged_currency}
            </td>
          </tr>
          <tr>
            <td>charge transaction id:</td>
            <td>{charged_transaction_id}</td>
          </tr>
          <tr>
            <td>charge id: (payment provider id)</td>
            <td>{charged_charge_id}</td>
          </tr>
        </tbody>
      </Table>
      <b>Sent</b>
      <Table striped bordered hover size="sm">
        <tbody>
          <tr>
            <td>send at:</td>
            <td>{send_at}</td>
          </tr>
          <tr>
            <td>send status:</td>
            <td>{send_status}</td>
          </tr>
          <tr>
            <td>send error:</td>
            <td>{send_error}</td>
          </tr>
          <tr>
            <td>send emails used:</td>
            <td>{send_emails_used}</td>
          </tr>
          <tr>
            <td>delivery link:</td>
            <td>
              {send_delivery_link && (
                <a href={send_delivery_link}>customer.io</a>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
